@if (documents()) {
  <app-label-value
    label="Documents"
    [value]="documents().documents.length.toString()"
  ></app-label-value>
}
@for (document of documents().documents; track $index) {
  <button mat-icon-button (click)="onClick(document)" [matTooltip]="document.name">
    <app-text-icon [text]="document.tag | documentTagToTextIcon"></app-text-icon>
  </button>
}
